import { getAPIPath, requestGooseAPI } from '../shared/request'
import type { BookingSearchConfigsClientDto } from '../types/api'
import { CLIENT_BOOKING_SEARCH_CONFIGS_PATH } from '../types/constants'

export const ClientBookingSearchConfigsService = {
  getData: (locationName: string, serviceTypeName: string): Promise<BookingSearchConfigsClientDto> => {
    return requestGooseAPI<BookingSearchConfigsClientDto>({
      url: getAPIPath(CLIENT_BOOKING_SEARCH_CONFIGS_PATH, { locationId: locationName, serviceTypeName }),
      method: 'GET',
    })
  },
}
